import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AlertController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

import { TokenService } from './token.service';
import { Router } from '@angular/router';


@Injectable({
    providedIn: 'root'
})
export class VersionService{

    private apiUrl = environment.apiUrl;

    private versionActual = Number(environment.appVersion);

    private club = environment.club;


    constructor(private http: HttpClient,
            private tokenService: TokenService,
            private router: Router,
        private alertController: AlertController) {
        // Inicializar comprobando la version de la app
        this.comprobarVersionAppActual();
    }

    //Inicializar comprobando la version de la app
    // Solo se comprobara 
    public async comprobarVersionAppActual(): Promise<void> {

        let plataformaActual = Capacitor.getPlatform();

        if(Capacitor.getPlatform() === 'web'){
            plataformaActual = 'android';
        }

        // Datos a enviar al servidor
        const body = {
            plataforma: plataformaActual, // Ejemplo: 'android', 'ios', 'web'
            nombre: this.club // Nombre de la app
        };

        // Consultar endpoint para obtener la versión mínima requerida
        const version: any = await this.http.post(`${this.apiUrl}versiones/obtener-version`, body).toPromise();
        const versionMinima = Number(version.versionMinima); // Versión mínima requerida
        const versionActualEnStore = Number(version.versionActual); // Versión actual en el servidor

        // Comparar versiones
        if (this.versionActual < versionMinima) {
            // Mostrar alerta si la versión es menor a la mínima requerida
            const mensaje = 'Hay una nueva versión de la aplicación disponible. Por favor, actualice para continuar usando la app.';
            await this.mostrarAlertaCerrarSesion(mensaje);
        } else if (this.versionActual < versionActualEnStore) {
            console.log('La versión de la app es la mínima requerida.');
            const mensaje = 'Hay una nueva versión de la aplicación disponible. Le recomendamos actualizar para disfrutar de las últimas mejoras.';
            await this.mostrarAlertaUnicaPorDia(mensaje);
        } else {
            console.log('La versión de la app está actualizada.');
        }

    }



    // Alerta una vez al día
    async mostrarAlertaUnicaPorDia(mensaje: string): Promise<void> {
        const hoy = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
        const ultimaAlerta = localStorage.getItem('fechaAlertaVersion');

        if (ultimaAlerta !== hoy) {
            await this.mostrarAlertaOk(mensaje);
            localStorage.setItem('fechaAlertaVersion', hoy);
        }
    }

    // Alerta que cierra la app
    async mostrarAlertaCerrarSesion(mensaje: string): Promise<void> {
        const alert = await this.crearAlert('¡Aviso!', mensaje);
        alert.present().then(async () => {
            // navigator['app'].exitApp(); // Cierra la app
            // Cierra Sesion de la app
            await this.tokenService.logOut();
            // Redirigir a Pantalla de versiones
            // this.router.navigate(['/version']);
            this.router.navigate(['/version'], { replaceUrl: true });
        });
    }


    // Manejo de Alertas
    async crearAlert(header: string, mensaje: string): Promise<HTMLIonAlertElement> {
        const alert = await this.alertController.create({
            header: header,
            message: mensaje,
            buttons: ['OK']
        });
        return alert;
    }

    async mostrarAlertaOk(mensaje: string): Promise<void> {
        const alert = await this.crearAlert('¡Aviso!', mensaje);
        alert.present().then(async () => {
            // this.modalController.dismiss();
        });
    }

    async mostrarAlertaError(mensaje: string): Promise<void> {
        const alert = await this.crearAlert('¡Error!', mensaje);
        alert.present().then(async () => {
            // this.modalController.dismiss();
        });
    }
}
